import { SelectComponent, type } from "./SelectArchivos";

class CustomFormFields {
  constructor(formFields) {
    formFields.register(type, SelectComponent);
  }
}


export default {
    __init__: [ 'selectUsuarios' ],
    selectUsuarios: [ 'type', CustomFormFields ]
  };